import React from 'react';
import { useSelector } from 'react-redux';
import './PromotionNext.css';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';
import { PromotionsService } from '../../../../../shared/src/services/promotions.service';

export const PromotionNext = ({
    nextPromotion,
    colors,
}) => {
    const { language: { iso2 } } = useSelector((state) => state.app);
    const { t } = useTranslations();

    if (!nextPromotion.title && !nextPromotion.image && !nextPromotion.startDateIso) {
        return null;
    }

    const colorTheme = colors.colorTheme;
    const colorVars = PromotionsService.getFoldColorsVariables(colors);

    const startDate = new Date(nextPromotion.startDateIso);
    const dateFormatted = PromotionsService.formatPromotionDate(
        startDate,
        iso2,
    );

    const nextClasses = [
        'asg-promotion-fold__next',
        `asg-promotion-fold__next--${colorTheme}`,
    ];

    return (
        <div className={nextClasses.join(' ')} style={colorVars}>
            <div className="asg-promotion-fold__next-content">
                <div className="asg-promotion-fold__next-text-block">
                    <div className="asg-promotion-fold__next-title">{t('comingSoon')}</div>
                    <div className="asg-promotion-fold__next-text">{nextPromotion.title}</div>
                </div>
                <div className="asg-promotion-fold__next-date">{dateFormatted}</div>
                <img
                    className="asg-promotion-fold__next-img"
                    src={nextPromotion.image} alt="Next limited-time promotion"
                />
            </div>
        </div>
    );
};
